// extracted by mini-css-extract-plugin
export var emailBlockLink = "_lb-0";